import React, { Component } from 'react';
import apiServiceProvider from './ApiService';
import ComponentHeader from '../../../../common/ComponentHeader';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import CustomCard from '../../../../Components-2025/QuestionBank/CustomCard';
import CustomCardHeader from '../../../../Components-2025/QuestionBank/CustomCardHeader';
import CustomCardBody from '../../../../Components-2025/QuestionBank/CustomCardBody';
import { Col, Row } from 'reactstrap';
import ViewQuestion from '../../../../Components-2025/QuestionBank/ViewQuestion';
import QuestionBankFooter from '../../../../Components-2025/QuestionBank/QuestionBankFooter';
import Timer from '../../../../Components-2025/QuestionBank/Timer/index';
import { answerKey, chapterIdKey, correctChoiceKey, questionIdKey } from './ApiAttributesKays';
import AppRoutes from '../../../config/AppRoutes';
import { showSuccess } from '../../../../common/toast';
import FlashCard from '../../../../components/FlashCard';
import ReportCard from '../../../../Components-2025/QuestionBank/ReportCard';
import questionBankIcon from '../../../../assets/img/question_bank/question_icon_blue.svg';
import { renderHTMLContent } from '../../../../common/function';
export default class QuestionView extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      selectedExamSubscriptionDetails: {},
      currentIndex: 0,
      currentQuestion: {},
      showAnswer: false,
      stopTimer: false,
      selectedChoice: '',
      isFlashCardHidden: true,
      questionData: [],
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  //* ============================{{ COMPONENT DID MOUNT START HERE }}==========================================
  async componentDidMount() {
    const { state } = this.props.location;
    //^ IF WE HAVE A QUESTIONS STATE FROM PREVIOUS COMPONENT THEN DIRECTLY SET IT OTHERWISE FETCH DATA FROM API
    if (state && state.questionData && state.questionData.length) {
      const { questionData } = state;
      this.setState({ questionData, isLoading: false });
      await this.onSetCurrentQuestion(questionData);
    } else {
      const { readingId, level } = this.props.params;
      const response = await apiServiceProvider['fetchQuestionsReadingWise']({ readingId, level });
      if (response.success) {
        const { questions } = response;
        await this.onSetCurrentQuestion(questions);
        this.setState({
          questionData: questions,
          isLoading: false,
        });
      }
    }
  }
  //* ============================{{ COMPONENT DID MOUNT START HERE }}==========================================

  onSetCurrentQuestion = async (questionsData) => {
    this.setState({ isLoading: true });
    const { questionId } = this.props.params;
    if (questionId !== ':questionId') {
      const index = questionsData.findIndex(
        (item) => item[questionIdKey] === parseInt(questionId, 10),
      );
      this.setState({
        currentIndex: index > -1 ? index : 0,
        currentQuestion: questionsData[index > -1 ? index : 0],
      });
    } else {
      this.setState({ currentQuestion: questionsData[0] });
    }
    this.setState({ isLoading: false });
  };

  //* ============================{{ QUESTION MOVE FORWARD AND PREVIOUS START HERE }}==========================================
  getPreviousQuestion = () => {
    const { currentIndex } = this.state;
    if (parseInt(currentIndex, 10) > 0) {
      this.replaceRoute(currentIndex - 1);
      this.resetStates();
    }
  };
  getNextQuestion = () => {
    const { questionData, currentIndex } = this.state;
    const index = parseInt(currentIndex, 10) + 1;
    if (index < questionData.length) {
      this.replaceRoute(index);
      this.resetStates();
    }
  };
  //* ============================{{ QUESTION MOVE FORWARD AND PREVIOUS ENDED HERE }}==========================================

  resetStates = () => {
    this.setState({
      showAnswer: false,
      showReportSection: false,
      selectedChoice: '',
      stopTimer: false,
    });
  };
  replaceRoute = (index) => {
    const { questionData } = this.state;
    const { readingId, questionId, level } = this.props.params;
    const { router } = this.context;

    const id = questionData[index] ? questionData[index].id : questionId;
    router.push({
      pathname: AppRoutes.FRM_V2_QUESTION_BANK_QUESTION_VIEW.replace(':level', level)
        .replace(':readingId', readingId)
        .replace(':questionId', id),
    });
    this.setState({ currentIndex: index, currentQuestion: questionData[index] });
  };

  validateQuestion = () => {
    const { selectedChoice, questionData, currentIndex } = this.state;
    const { level } = this.props.params;
    if (selectedChoice) {
      this.setState({ stopTimer: true });
      let right_answer = 0;
      if (
        questionData[currentIndex] &&
        questionData[currentIndex][correctChoiceKey] === selectedChoice
      )
        right_answer = 1;
      const data = {
        time_done: this.timerValue,
        question_id: questionData[currentIndex][questionIdKey],
        right_answer,
        level,
      };
      const result = apiServiceProvider['saveQuestionAttemptStats'](data);
      if (result.success) {
        showSuccess(messages.QUESTION_STATS_SAVED);
      }
      this.setState({ showAnswer: true });
    }
  };
  setAnswer = (answer) => {
    this.setState({ selectedChoice: answer[0] });
  };
  onSaveItemChange = (status) => {
    this.setState({ isFlashCardHidden: status });
  };
  toggleReportSection = () =>
    this.setState((prevState) => ({ showReportSection: !prevState.showReportSection }));

  getTimerValue = (timerValue) => {
    this.timerValue = timerValue;
  };
  hideReportSection = () => {
    this.setState({ showReportSection: false });
  };
  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      showAnswer,
      selectedChoice,
      isFlashCardHidden,
      stopTimer,
      showReportSection,
    } = this.state;
    const { level, readingId } = this.props.params;
    const { router } = this.context;

    return (
      <div>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader title={messages.QUESTION_BANK}>
          <div>
            <CustomButton
              className='mr-1'
              onClick={() =>
                router.push({
                  pathname: AppRoutes.FRM_V2_QUESTION_BANK_QUESTION_LIST.replace(
                    ':level',
                    level,
                  ).replace(':readingId', readingId),
                })
              }
            >
              {messages.CHANGE_QUESTION}
            </CustomButton>
            <CustomButton
              onClick={() =>
                router.push({
                  pathname: AppRoutes.FRM_V2_QUESTION_BANK_READING_LIST.replace(
                    ':level',
                    level,
                  ).replace(':chapterId', currentQuestion && currentQuestion[chapterIdKey]),
                })
              }
            >
              {messages.CHANGE_READING}
            </CustomButton>
          </div>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}=========================================== */}
        {/* //* ============================{{ QUESTION CARD WITH TIME START HERE }}============================================= */}
        <LoaderWrapper isLoading={isLoading}>
          <CustomCard>
            {currentQuestion && Object.keys(currentQuestion).length > 0 ? (
              <div>
                <CustomCardHeader
                  headingText={`${currentQuestion.name} (Q. ${currentQuestion.id})`}
                  showPreviousButton={true}
                  showNextButton={true}
                  headerImage={questionBankIcon}
                  arrayLength={questionData.length}
                  disabledPreviousButton={currentIndex < 1}
                  disabledNextButton={!(currentIndex < questionData.length - 1)}
                  getPreviousQuestion={this.getPreviousQuestion}
                  getNextQuestion={this.getNextQuestion}
                />
                <CustomCardBody>
                  <Row>
                    <Col sm={9} xs={12}>
                      {/* //^ ============================{{ QUESTION VIEW CARD START HERE }}============================================= */}
                      <ViewQuestion
                        {...currentQuestion}
                        {...this.props}
                        setAnswer={this.setAnswer}
                        showAnswer={showAnswer}
                        correctChoice={currentQuestion && currentQuestion[correctChoiceKey]}
                        selectedChoice={selectedChoice}
                      >
                        <QuestionBankFooter
                          savePayLoad={{
                            question_id: currentQuestion && currentQuestion[questionIdKey],
                            level,
                          }}
                          validateQuestion={this.validateQuestion}
                          favItemId={currentQuestion && currentQuestion.id}
                          setChildRef={this.childRef}
                          apiServiceProvider={apiServiceProvider}
                          onSaveItemChange={this.onSaveItemChange}
                          toggleReportSection={this.toggleReportSection}
                        />
                      </ViewQuestion>
                      {/* //^ ============================{{ QUESTION VIEW CARD ENDED HERE }}============================================= */}
                    </Col>
                    <Col sm={3} xs={12}>
                      {/* //^ ============================{{ TIMER START HERE }}============================================= */}
                      <Timer
                        getTimerValue={this.getTimerValue}
                        stopTimer={stopTimer}
                        shouldFetchFromServer={true}
                        key={currentQuestion && currentQuestion.id}
                      />
                      {/* //^ ============================{{ TIMER ENDED HERE }}============================================= */}
                    </Col>
                  </Row>
                </CustomCardBody>
              </div>
            ) : (
              <h1 className='text-center pt-3 pb-3'>{messages.NO_DATA_FOUND}</h1>
            )}
          </CustomCard>
        </LoaderWrapper>
        {/* //* ============================{{ QUESTION CARD WITH TIME ENDED HERE }}============================================= */}
        {/* //^ ============================{{ ATTEMPTED QUESTION ANSWER START HERE }}============================================= */}
        {showAnswer && (
          <Row>
            <Col>
              <CustomCard className='font-lusitana font-16px'>
                <CustomCardHeader
                  headingText={
                    selectedChoice === currentQuestion[correctChoiceKey] ? 'Correct' : 'Incorrect'
                  }
                  headerImage=''
                  className={`text-uppercase ${selectedChoice === currentQuestion[correctChoiceKey]
                    ? 'text_success'
                    : 'text_failure'
                    }`}
                />
                <CustomCardBody>
                  {renderHTMLContent(
                    currentQuestion && currentQuestion[answerKey],
                    "span"
                  )}
                </CustomCardBody>
              </CustomCard>
            </Col>
          </Row>
        )}
        {/* //^ ============================{{ ATTEMPTED QUESTION ANSWER ENDED HERE }}============================================= */}
        <FlashCard
          item={currentQuestion}
          type='question'
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam='frm'
          level={level}
        />
        {showReportSection && (
          <ReportCard
            hideReportSection={this.hideReportSection}
            apiServiceProvider={apiServiceProvider}
            itemId={currentQuestion && currentQuestion[questionIdKey]}
            keyId='question_id'
          />
        )}
        {/* //* ============================{{ QUESTION CARD WITH TIME ENDED HERE }}============================================= */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionView/index.jsx